import React, { useState, useEffect } from "react";
import "./ScoresMode.css";

const ScoresMode = () => {
  const [rounds, setRounds] = useState([]);
  const [selectedRound, setSelectedRound] = useState(null);

  useEffect(() => {
    const savedRounds = JSON.parse(
      localStorage.getItem("monkeyClock_rounds") || "[]"
    );
    setRounds(savedRounds);
    if (savedRounds.length > 0) {
      setSelectedRound(savedRounds[savedRounds.length - 1]);
    }
  }, []);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  if (rounds.length != 0) {
    return (
      <div className="scores-container">
        <div className="scores-header">
          <h2>Round History</h2>
          <select
            className="round-selector"
            value={selectedRound?.id || ""}
            onChange={(e) => {
              const round = rounds.find((r) => r.id === Number(e.target.value));
              setSelectedRound(round);
            }}
          >
            {rounds.map((round) => (
              <option key={round.id} value={round.id}>
                {formatDate(round.date)} - Score: {round.score}
              </option>
            ))}
          </select>
        </div>

        {selectedRound && (
          <div className="round-details">
            <div className="stats-grid">
              <div className="stat-item date-item">
                <h3>Date</h3>
                <p className="date-text">{formatDate(selectedRound.date)}</p>
              </div>
              <div className="stat-item">
                <h3>Duration</h3>
                <p>{selectedRound.duration}s</p>
              </div>
              <div className="stat-item">
                <h3>Total Attempts</h3>
                <p>{selectedRound.totalAttempts}</p>
              </div>
              <div className="stat-item">
                <h3>Correct Answers</h3>
                <p>{selectedRound.correctAnswers}</p>
              </div>
              <div className="stat-item">
                <h3>Final Score</h3>
                <p>{selectedRound.score}</p>
              </div>
              <div className="stat-item">
                <h3>Accuracy</h3>
                <p>{selectedRound.accuracy}%</p>
              </div>
              <div className="stat-item">
                <h3>Avg Time Difference</h3>
                <p>{selectedRound.avgDifference} min</p>
              </div>
            </div>

            <div className="attempts-list">
              <h3>Attempt Details</h3>
              <table>
                <thead>
                  <tr>
                    <th>Attempt #</th>
                    <th>Target Time</th>
                    <th>Your Input</th>
                    <th>Difference</th>
                    <th>Reaction Time</th>
                    <th>Points</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedRound.attemptDetails.map((attempt, index) => (
                    <tr
                      key={index}
                      className={
                        attempt.points > 0 ? "good-attempt" : "poor-attempt"
                      }
                    >
                      <td>{attempt.attempt}</td>
                      <td>{attempt.targetTime}</td>
                      <td>{attempt.userInput}</td>
                      <td>{attempt.difference} min</td>
                      <td>{attempt.inputDuration}s</td>
                      <td>
                        {attempt.points > 0
                          ? `+${attempt.points}`
                          : attempt.points}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div className="scores-container">
        <h2>No Rounds Played Yet</h2>
        <p>Complete some ranked rounds to see your statistics here!</p>
      </div>
    );
  }
};

export default ScoresMode;
